import analyticsTrack from '@lib/analytics/analyticsTrack';

const trackLinkClick = (linkname: string) => () => {
  analyticsTrack('footer_clicked', { linkname });
};

export default trackLinkClick;
